import { UnitTypes } from "constant";

export function getNorthernMostPoint(polygon: [number, number][]) {
  // Найбільший lat (другий елемент)
  return polygon.reduce((max, point) => (point[0] > max[0] ? point : max));
}

export const createSquare = (center, size) => {
  const [lat, lng] = center;
  const halfSize = size / 2;

  const lngCorrection = halfSize / Math.cos((lat * Math.PI) / 180);

  return [
    [lat, lng],
    [lat, lng + lngCorrection],
    [lat - halfSize, lng + lngCorrection],
    [lat - halfSize, lng]
  ];
};

export const getPolygonCenter = (marker) => {
  if (marker?.geo_data?.type === UnitTypes.POINT) {
    return marker.geo_data.coordinates;
  } else if (
    marker?.geo_data?.type === UnitTypes.POLYGON &&
    Array.isArray(marker.geo_data.coordinates) &&
    marker.geo_data.coordinates.length !== 4
  ) {
    const coords = marker.geo_data.coordinates[0][0];

    return coords;
  }
  return marker.geo_data.coordinates[0];
};
